import { render } from "./Product.vue?vue&type=template&id=7dce6d18&scoped=true"
import script from "./Product.vue?vue&type=script&lang=js"
export * from "./Product.vue?vue&type=script&lang=js"

import "./Product.vue?vue&type=style&index=0&id=7dce6d18&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-7dce6d18"

export default script